	/*! npm.im/object-fit-images 3.2.4 */
var objectFitImages=function(){"use strict";function t(t,e){return"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='"+t+"' height='"+e+"'%3E%3C/svg%3E"}function e(t){if(t.srcset&&!p&&window.picturefill){var e=window.picturefill._;t[e.ns]&&t[e.ns].evaled||e.fillImg(t,{reselect:!0}),t[e.ns].curSrc||(t[e.ns].supported=!1,e.fillImg(t,{reselect:!0})),t.currentSrc=t[e.ns].curSrc||t.src}}function i(t){for(var e,i=getComputedStyle(t).fontFamily,r={};null!==(e=u.exec(i));)r[e[1]]=e[2];return r}function r(e,i,r){var n=t(i||1,r||0);b.call(e,"src")!==n&&h.call(e,"src",n)}function n(t,e){t.naturalWidth?e(t):setTimeout(n,100,t,e)}function c(t){var c=i(t),o=t[l];if(c["object-fit"]=c["object-fit"]||"fill",!o.img){if("fill"===c["object-fit"])return;if(!o.skipTest&&f&&!c["object-position"])return}if(!o.img){o.img=new Image(t.width,t.height),o.img.srcset=b.call(t,"data-ofi-srcset")||t.srcset,o.img.src=b.call(t,"data-ofi-src")||t.src,h.call(t,"data-ofi-src",t.src),t.srcset&&h.call(t,"data-ofi-srcset",t.srcset),r(t,t.naturalWidth||t.width,t.naturalHeight||t.height),t.srcset&&(t.srcset="");try{s(t)}catch(t){window.console&&console.warn("https://bit.ly/ofi-old-browser")}}e(o.img),t.style.backgroundImage='url("'+(o.img.currentSrc||o.img.src).replace(/"/g,'\\"')+'")',t.style.backgroundPosition=c["object-position"]||"center",t.style.backgroundRepeat="no-repeat",t.style.backgroundOrigin="content-box",/scale-down/.test(c["object-fit"])?n(o.img,function(){o.img.naturalWidth>t.width||o.img.naturalHeight>t.height?t.style.backgroundSize="contain":t.style.backgroundSize="auto"}):t.style.backgroundSize=c["object-fit"].replace("none","auto").replace("fill","100% 100%"),n(o.img,function(e){r(t,e.naturalWidth,e.naturalHeight)})}function s(t){var e={get:function(e){return t[l].img[e?e:"src"]},set:function(e,i){return t[l].img[i?i:"src"]=e,h.call(t,"data-ofi-"+i,e),c(t),e}};Object.defineProperty(t,"src",e),Object.defineProperty(t,"currentSrc",{get:function(){return e.get("currentSrc")}}),Object.defineProperty(t,"srcset",{get:function(){return e.get("srcset")},set:function(t){return e.set(t,"srcset")}})}function o(){function t(t,e){return t[l]&&t[l].img&&("src"===e||"srcset"===e)?t[l].img:t}d||(HTMLImageElement.prototype.getAttribute=function(e){return b.call(t(this,e),e)},HTMLImageElement.prototype.setAttribute=function(e,i){return h.call(t(this,e),e,String(i))})}function a(t,e){var i=!y&&!t;if(e=e||{},t=t||"img",d&&!e.skipTest||!m)return!1;"img"===t?t=document.getElementsByTagName("img"):"string"==typeof t?t=document.querySelectorAll(t):"length"in t||(t=[t]);for(var r=0;r<t.length;r++)t[r][l]=t[r][l]||{skipTest:e.skipTest},c(t[r]);i&&(document.body.addEventListener("load",function(t){"IMG"===t.target.tagName&&a(t.target,{skipTest:e.skipTest})},!0),y=!0,t="img"),e.watchMQ&&window.addEventListener("resize",a.bind(null,t,{skipTest:e.skipTest}))}var l="fregante:object-fit-images",u=/(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g,g="undefined"==typeof Image?{style:{"object-position":1}}:new Image,f="object-fit"in g.style,d="object-position"in g.style,m="background-size"in g.style,p="string"==typeof g.currentSrc,b=g.getAttribute,h=g.setAttribute,y=!1;return a.supportsObjectFit=f,a.supportsObjectPosition=d,o(),a}();


jQuery.easing.easeOutQuint = function(x,t,b,c,d){
	return c*((t=t/d-1)*t*t*t*t + 1) + b;
};


const includeHeader = function(){
	
	const docRoot = window.doc_root;
	const locRoot = window.loc_root ? window.loc_root : docRoot;

	$.ajax({
		url: locRoot + 'include/header.html',
		cache: false,
		async: false, 
		success: function(html){
			html = html.replace(/\{\$doc_root\}/g, docRoot);
			html = html.replace(/\{\$loc_root\}/g, locRoot);
			$('#header').replaceWith(html);
            if(window.page_slug){
                $('header a[data-slug="'+window.page_slug+'"]').addClass('active')
            }
		}
	});

}

const includeFooter = function(){

	const docRoot = window.doc_root;
	const locRoot = window.loc_root ? window.loc_root : docRoot;

	$.ajax({
		url: locRoot + 'include/footer.html', 
		cache: false,
		async: false, 
		success: function(html){
			html = html.replace(/\{\$doc_root\}/g, docRoot);
			html = html.replace(/\{\$loc_root\}/g, locRoot);
			$('#footer').replaceWith(html);
		}
	});

}

includeHeader();
includeFooter();

const getUA = function(){
  
    let _ua = navigator.userAgent.toLowerCase();
    let _o = {
      ltIE6:typeof window.addEventListener == "undefined" && typeof document.documentElement.style.maxHeight == "undefined",
      ltIE7:typeof window.addEventListener == "undefined" && typeof document.querySelectorAll == "undefined",
      ltIE8:typeof window.addEventListener == "undefined" && typeof document.getElementsByClassName == "undefined",
      IE9: navigator.appVersion.toLowerCase().indexOf("msie 9.") != -1,
      IE10 : navigator.userAgent.match(/Trident\/[6]/i),
      IE11: navigator.userAgent.match(/Trident\/7\./),
      IE:document.uniqueID,
      Firefox:window.sidebar,
      Opera:window.opera,
      chrome: _ua.indexOf('chrome') > -1,
      //Webkit:!document.uniqueID && !window.opera && !window.sidebar && !window.orientation && window.localStorage,
      mobile:/android|iphone|ipad|ipod/i.test(navigator.userAgent.toLowerCase()),
      iphone:/iphone|ipod/i.test(_ua),
      android:/android/.test(_ua),
      ipad:/ipad/.test(_ua),
      tablet:undefined,
      smartphone:undefined,
      touch: window.ontouchstart === null
    }
    _o.tablet = _o.ipad;
    if(!_o.tablet && _o.android){ _o.tablet = !(/mobile/.test(_ua));}				
    _o.smartphone = _o.iphone || _o.android ? true : false;
    
    let v = [];
    if (/iP(hone|od|ad)/.test(navigator.platform)) {v = (navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);}
    let vAry = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];
    _o.iosV = vAry[0] ? vAry[0] : '';
  
    return _o;
    
  }

let onPageLoad = false;
const ua = getUA();

function pageScrollTo(tar, e, duration){
	var tar = tar.replace('#', '');

	if($('.award_projects').length){
		
		var prefix = 'award_projects';
		if($('.pagelinklist li:first a').attr('href').indexOf('companies') > -1){
			prefix = 'award_companies';
		}
		tar = prefix + tar;
	}

	if($('[data-id="' + tar + '"]').length || $('[id="' + tar + '"]').length || tar == 'header'){
		if(e)
		e.preventDefault();

		let elem = $('[data-id="' + tar + '"]').length ? $('[data-id="' + tar + '"]') : $('[id="' + tar + '"]');
		duration = duration ? duration : 1000;
		let diff = $('.ico_menu').is(':visible') ? 70 : 150;
		let pos = tar == 'header' ? 0 : elem.offset().top - diff;
		$('html,body').stop().animate({ scrollTop: pos }, duration, 'easeOutQuint');		
	}

}

$(function(){

	//スマホメニュー
	$(".ico_menu").on("click", function() {
		$('.spmenu').toggleClass('visible');
		$(this).toggleClass("active");
	});

    //スムーズスクロール
	$("a[href^=#]").on("click", function(){
		var Hash = $(this.hash);
		let diff = $('.ico_menu').is(':visible') ? 70 : 150;
		var HashOffset = $(Hash).offset().top - diff;
		$("html,body").animate({scrollTop:HashOffset}, 1200, 'easeOutQuint');
		return false;
	});
	//page topボタン
	$(function(){
		var pagetop=$('#gototop');
		pagetop.hide();

		$(window).on("scroll", function(){
			if($(this).scrollTop()>900){
				pagetop.fadeIn();
			}else{
				pagetop.fadeOut();
			}
		});
		pagetop.on("click", function(){
			$('body,HTML').animate({
			scrollTop: 0},900);
			return false;
		});
	});


	objectFitImages();

});


	if(location.hash){
		pageScrollTo(location.hash, null, 0);
	}



	

	/**************************************************

	PhotoSwipeをセットするためのJavaScript

	公式ドキュメントより
	http://photoswipe.com/documentation/getting-started.html

**************************************************/
var initPhotoSwipeFromDOM = function( gallerySelector ) {

    // parse slide data (url, title, size ...) from DOM elements 
    // (children of gallerySelector)
    var parseThumbnailElements = function(el) {
        var thumbElements = el.childNodes,
            numNodes = thumbElements.length,
            items = [],
            figureEl,
            linkEl,
            size,
            item;

        for(var i = 0; i < numNodes; i++) {

            figureEl = thumbElements[i]; // <figure> element

            // include only element nodes 
            if(figureEl.nodeType !== 1) {
                continue;
            }

            linkEl = figureEl.getElementsByTagName('a')[0]; // <a> element

            size = linkEl.getAttribute('data-size').split('x');

            // create slide object
            item = {
                src: linkEl.getAttribute('href'),
                w: parseInt(size[0], 10),
                h: parseInt(size[1], 10)
            };



            if(figureEl.children.length > 1) {
                // <figcaption> content
                item.title = figureEl.children[1].innerHTML; 
            }

            if(linkEl.children.length > 0) {
                // <img> thumbnail element, retrieving thumbnail url
                item.msrc = linkEl.children[0].getAttribute('src');
            } 

            item.el = figureEl; // save link to element for getThumbBoundsFn
            items.push(item);
        }

        return items;
    };

    // find nearest parent element
    var closest = function closest(el, fn) {
        return el && ( fn(el) ? el : closest(el.parentNode, fn) );
    };

    // triggers when user clicks on thumbnail
    var onThumbnailsClick = function(e) {
        e = e || window.event;
        e.preventDefault ? e.preventDefault() : e.returnValue = false;

        var eTarget = e.target || e.srcElement;

        // find root element of slide
        var clickedListItem = closest(eTarget, function(el) {
            return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
        });

        if(!clickedListItem) {
            return;
        }

        // find index of clicked item by looping through all child nodes
        // alternatively, you may define index via data- attribute
        var clickedGallery = clickedListItem.parentNode,
            childNodes = clickedListItem.parentNode.childNodes,
            numChildNodes = childNodes.length,
            nodeIndex = 0,
            index;

        for (var i = 0; i < numChildNodes; i++) {
            if(childNodes[i].nodeType !== 1) { 
                continue; 
            }

            if(childNodes[i] === clickedListItem) {
                index = nodeIndex;
                break;
            }
            nodeIndex++;
        }



        if(index >= 0) {
            // open PhotoSwipe if valid index found
            openPhotoSwipe( index, clickedGallery );
        }
        return false;
    };

    // parse picture index and gallery index from URL (#&pid=1&gid=2)
    var photoswipeParseHash = function() {
        var hash = window.location.hash.substring(1),
        params = {};

        if(hash.length < 5) {
            return params;
        }

        var vars = hash.split('&');
        for (var i = 0; i < vars.length; i++) {
            if(!vars[i]) {
                continue;
            }
            var pair = vars[i].split('=');  
            if(pair.length < 2) {
                continue;
            }           
            params[pair[0]] = pair[1];
        }

        if(params.gid) {
            params.gid = parseInt(params.gid, 10);
        }

        if(!params.hasOwnProperty('pid')) {
            return params;
        }
        params.pid = parseInt(params.pid, 10);
        return params;
    };

    var openPhotoSwipe = function(index, galleryElement, disableAnimation) {
        var pswpElement = document.querySelectorAll('.pswp')[0],
            gallery,
            options,
            items;

        items = parseThumbnailElements(galleryElement);

        // define options (if needed)
        options = {
            index: index,

            // define gallery index (for URL)
            galleryUID: galleryElement.getAttribute('data-pswp-uid'),

            getThumbBoundsFn: function(index) {
                // See Options -> getThumbBoundsFn section of documentation for more info
                var thumbnail = items[index].el.getElementsByTagName('img')[0], // find thumbnail
                    pageYScroll = window.pageYOffset || document.documentElement.scrollTop,
                    rect = thumbnail.getBoundingClientRect(); 

                return {x:rect.left, y:rect.top + pageYScroll, w:rect.width};
            }

        };

        if(disableAnimation) {
            options.showAnimationDuration = 0;
        }

        // Pass data to PhotoSwipe and initialize it
        gallery = new PhotoSwipe( pswpElement, PhotoSwipeUI_Default, items, options);
        gallery.init();
    };

    // loop through all gallery elements and bind events
    var galleryElements = document.querySelectorAll( gallerySelector );

    for(var i = 0, l = galleryElements.length; i < l; i++) {
        galleryElements[i].setAttribute('data-pswp-uid', i+1);
        galleryElements[i].onclick = onThumbnailsClick;
    }

    // Parse URL and open gallery if it contains #&pid=3&gid=1
    var hashData = photoswipeParseHash();
    if(hashData.pid > 0 && hashData.gid > 0) {
        openPhotoSwipe( hashData.pid - 1 ,  galleryElements[ hashData.gid - 1 ], true );
    }
};


if(ua.mobile){
  initPhotoSwipeFromDOM( '.my-gallery' ) ;
} else {
	$('.figure img').unwrap('a')
}